import { observable } from 'mobx';
import Client from '../../common/client';
import moment from 'moment';

const CardBillListStore = observable({
  cardBillList: null,
  cusEntAmount: null,
  bankList: null,
  visibleWithdrawPopup: false,
  visibleAccountInfoPopup: false,
  accountTypeList: null,
  selectedDong: null,

  *getCardBillList(fromDate, toDate) {
    try {
      const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

      if (!fromDate) {
        // fromDate = moment().add(-1, 'months').format('YYYYMMDD');
        fromDate = moment().format('YYYYMMDD');
      }

      if (!toDate) {
        // toDate = moment().add(-1, 'days').format('YYYYMMDD');
        toDate = moment().format('YYYYMMDD');
      }

      let response = yield Client.post('/Cems/CustomerEntertainment/CusEntMileageHistorySearch/', {
        entCode: code,
        companyCode: '1000000098',
        fromDate: fromDate,
        toDate: toDate,
      });

      const cardBillList = response.data;

      if (cardBillList) {
        this.cardBillList = cardBillList;
      } 
    } catch (error) {
      console.log(`CardBillListStore > *getCardBillList : ${error.message}`);
    }
  },

  *getCusEntAmount() {
    try {
      const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

      let response = yield Client.post('/Cems/CustomerEntertainment/CusEntMileageAmountSearch/', {
        entCode: code,
        companyCode: '1000000098',
      });

      const cusEntAmount = response.data[0];

      if (cusEntAmount) {
        this.cusEntAmount = cusEntAmount;
      } else {
        this.cusEntAmount = [];
      }
    } catch (error) {
      console.log(`CardBillListStore > *getCusEntAmount : ${error.message}`);
    }
  },

  // 출금
  setVisibleWithdrawPopup(visible) {
    // console.log('setVisibleWithdrawPopup : ', visible);
    this.visibleWithdrawPopup = visible;
  },

  *insertCusEntWithdrawRequest(withdrawAmount) {
    const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

    if (!code || code === '') {
      return { error: true, message: '업소고객코드를 확인할 수 없습니다.' };
    }

    // console.log(code);
    // console.log(withdrawAmount);

    try {
      const response = yield Client.post('/Cems/CustomerEntertainment/CusEntWithdrawRequestInsert/', {
        entCode: code,
        companyCode: '1000000098',
        withdrawAmount: withdrawAmount,
      });

      // console.log('CardBillStore > *insertCusEntWithdrawRequest response : ', response);

      var result = response.data[0];

      if (result.ResultYN) {
        return { error: false, message: result.ResultMessage};
      } else {
        return { error: true, message: result.ResultMessage };
      }

      // return { error: true, message: 'test' };
    } catch (error) {

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 출금계좌편집
  setVisibleAccountInfoPopup(visible) {
    // console.log('setVisibleAccountInfoPopup : ', visible);
    this.visibleAccountInfoPopup = visible;
  },

  *getBankList() {
    try {
      let response = yield Client.post('/Cems/CustomerEntertainment/BankListSearch/', {
        companyCode: '1000000098',
      });
  
      const bankList = response.data;

      // console.log(bankList);

      if (bankList) {
        this.bankList = bankList;
      }      
    } 
    catch (error) {
      console.log(`CardBillListStore > *getBankList : ${error.message}`)
    }
  },

  *updateCusEntAccountInfo(accountInfo) {
    const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

    if (!code || code === '') {
      return { error: true, message: '업소고객코드를 확인할 수 없습니다.' };
    }

    // console.log(code);
    // console.log(accountInfo);

    try {
      const response = yield Client.post('/Cems/CustomerEntertainment/CusEntAccountInfoUpdate/', {
        entCode: code,
        companyCode: '1000000098',
        bankCode: accountInfo.bankCode,
        accountNo: accountInfo.accountNo,
        bankOwnerName: accountInfo.bankOwnerName
      });

      // console.log('CardBillStore > *updateCusEntAccountInfo response : ', response);

      var result = response.data[0];

      if (result.ResultYN) {
        return { error: false, message: result.ResultMessage};
      } else {
        return { error: true, message: result.ResultMessage };
      }

      // return { error: true, message: 'test' };
    } catch (error) {

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  *getAccountTypeList() {
    try {
      let response = yield Client.post('/Cems/CustomerEntertainment/AccountTypeListSearch/', {
        companyCode: '0000000003',
      });
  
      const accountTypeList = response.data;

      // console.log(accountTypeList);

      if (accountTypeList) {
        this.accountTypeList = accountTypeList;
      }      
    } 
    catch (error) {
      console.log(`CardBillListStore > *getAccountTypeList : ${error.message}`)
    }
  },

  *searchDong(dong) {
    try {
      let response = yield Client.post('/Cems/CustomerEntertainment/DongSearch/', {
        dong: dong,
      });
  
      const selectedDong = response.data;

      // console.log(selectedDong);

      if (selectedDong) {
        this.selectedDong = selectedDong;
      }      
    } 
    catch (error) {
      console.log(`CardBillListStore > *searchDong : ${error.message}`)
    }
  },

  clear() {
    this.cardBillList = null;
    this.bankList = null;
    this.accountTypeList = null;
  },
});

export default CardBillListStore;
